<div class="container-fluid">

  <app-content-tab-list activeTab="0" type="communication" category="communication"></app-content-tab-list>

  <div class="row section1 mt-4 align-items-center">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">News</h5>
        <p class="home-subtitle">List of all Articles</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage">
        <!-- <div> <a href="#"><button class="btn btn-primary btn-deshboard">Export list</button></a></div> -->
        <div>
          <a routerLink="/news/new"><button class="btn btn-primary btn-dashboard mt-2">
            <i class="las la-plus"></i>Create new Article
          </button></a>
        </div>
        <div class="filter-row filter-row1">
          <div class="form-label show">Filter by :</div>
          <div class="select-wrapper-sm">
            <select class="form-control border-0 input-sm" name="news-filter" [(ngModel)]="filter" (ngModelChange)="getNews()">
              <option disabled value=""  >--select--</option>
              <option value="1">Opinion</option>
              <option value="2">Article</option>
              <option value="3">News</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-------end profile with button design--------->
  <!-----------user table------------------>
  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Title</th>
              <th scope="col">Short Description</th>
              <th scope="col">Created By</th>
              <th scope="col">Created At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @if (!loading && !!news?.length) {
            <tbody>
              @for (article of news; track article; let i = $index) {
                <tr class="client">
                  <td>{{ article.id }}</td>
                  <td>{{ article.title }}</td>
                  <td>{{ article.shortDescription }}</td>
                  <td>{{ article.admin.fullName }}</td>
                  <td>{{ createdAt[i] }}</td>
                  <td class="action">
                    <div class="dropdown">
                      <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <a class="   mr-3 text-primary py-2 text-nowrap">
                          View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                          <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap"
                            [routerLink]="['/news/', article.id]">
                            <i class="las la-eye mb-1 la-lg  align-middle mr-0"></i> View</a>
                            <a class=" dropdown-item  text-danger border-bottom py-2 text-nowrap"
                              (click)="remove(article.id)">
                              <i class="las la-trash mb-1 la-lg align-middle mr-0"></i> Delete</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
                @if (loading) {
                  <tbody>
                    @for (q of loaders; track q; let qi = $index) {
                      <tr class="client">
                        <td>
                          <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                        </td>
                        <td>
                          <ngx-skeleton-loader [theme]="{ width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                        </td>
                        <td>
                          <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                        </td>
                        <td>
                          <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                        </td>
                        <td>
                          <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                        </td>
                        <td>
                          <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
              @if (!loading && !news?.length) {
                <div class="d-flex align-items-center justify-content-center py-5">
                  No news found
                </div>
              }
            </div>
          </div>
        </div>
      </div>
